const GISMap = () => {

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <iframe
        id='earth'
        style={{ flexGrow: 1, border: 'none' }}
        src="https://ee-limspak9.projects.earthengine.app/view/newapp"
        frameBorder="0"
        title='Map'
      />
      <div style={{
        position: 'fixed',
        top: 0,
        right: 0,
        width: '220px',
        height: '67px',
        backgroundColor: 'rgb(250,250,250 )',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
      }}>
        <div style={{ color: 'black', fontSize: '28px', fontWeight: 'bold' }}>
          <pre></pre>
        </div>
      </div>
    </div>
  );
};

export default GISMap;
